<template>
    <section>

        <b-field :label="__('strings.product.retailer')">
            <b-dropdown
                class="filter-dropdown"
                v-model="currentFilters.retailers"
                multiple
                aria-role="list"
                scrollable
                expanded>
                <button class="button is-primary" type="button" slot="trigger">
                    <span>{{ __('strings.product.selected_f') }} ({{ currentFilters.retailers.length }})</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item
                    v-for="retailer in retailers.data"
                    :value="retailer.id"
                    :key="retailer.id"
                    aria-role="listitem">
                    <span>{{ retailer.name }}</span>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>

        <b-field :label="__('strings.product.stock')">
            <b-dropdown
                class="filter-dropdown"
                v-model="currentFilters.in_stock"
                multiple
                aria-role="list"
                scrollable
                expanded>
                <button class="button is-primary" type="button" slot="trigger">
                    <span>{{ __('strings.product.selected_f') }} ({{ currentFilters.in_stock.length }})</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item
                    v-for="stock in stocks.data"
                    :value="stock.id"
                    :key="stock.id"
                    aria-role="listitem">
                    <span>{{ stock.name }}</span>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>

        <b-field :label="__('strings.product.gender')" :type="{'is-danger': genders.error}" :message="genders.error">
            <b-dropdown
                class="filter-dropdown"
                v-model="currentFilters.gender_id"
                multiple
                aria-role="list"
                scrollable
                expanded>
                <button v-if="genders.loading" class="button is-primary" type="button" slot="trigger" >
                    <span>{{`Loading ...`}}</span>
                </button>
                <button v-if="!genders.loading" class="button is-primary" type="button" slot="trigger">
                    <span>{{ __('strings.product.selected_f') }} ({{ currentFilters.gender_id.length }})</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item
                    v-for="gender in genders.data"
                    :value="gender.id"
                    :key="gender.id"
                    aria-role="listitem">
                    <span>{{ gender.name }}</span>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>

        <b-field :label="__('strings.product.season')" :type="{'is-danger': seasons.error}" :message="seasons.error">
            <b-dropdown
                class="filter-dropdown"
                v-model="currentFilters.season_id"
                multiple
                aria-role="list"
                scrollable
                expanded>
                <button v-if="seasons.loading" class="button is-primary" type="button" slot="trigger" >
                    <span>{{`Loading ...`}}</span>
                </button>
                <button v-if="!seasons.loading" class="button is-primary" type="button" slot="trigger">
                    <span>{{ __('strings.product.selected_f') }} ({{ currentFilters.season_id.length }})</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item
                    v-for="season in seasons.data"
                    :value="season.id"
                    :key="season.id"
                    aria-role="listitem">
                    <span>{{ season.name }}</span>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>

        <b-field :label="__('strings.product.category')" :type="{'is-danger': categories.error}" :message="categories.error">
            <b-dropdown
                class="filter-dropdown"
                v-model="currentFilters.category_id"
                multiple
                aria-role="list"
                scrollable
                expanded>
                <button v-if="categories.loading" class="button is-primary" type="button" slot="trigger" >
                    <span>{{`Loading ...`}}</span>
                </button>
                <button v-if="!categories.loading" class="button is-primary" type="button" slot="trigger">
                    <span>{{ __('strings.product.selected_f') }} ({{ currentFilters.category_id.length }})</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item
                    v-for="category in categories.data"
                    :value="category.id"
                    :key="category.id"
                    aria-role="listitem">
                    <span><strong v-text="getCategoryPath(category)"></strong> {{ category.name }}</span>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>

        <b-field :label="__('strings.product.brand')" :type="{'is-danger': brands.error}" :message="brands.error">
            <div style="display:block">
            <v-select 
                multiple 
                v-model="selectedBrands"
                :filter="findBrand"
                :loading="brands.loading" 
                placeholder="Cerca brand"
                :options="filterBrands"
               
                >
                </v-select>
            </div>

          
            
        </b-field>

        <b-field class="mt-5 has-text-right">
            <p class="control">
                <b-button class="mr-3"
                          @click="removeFilters"
                >
                    {{ __('strings.product.reset_filters') }}
                </b-button>
                <b-button class="is-primary"
                          @click="handleSearchSubmit"
                >
                    {{ __('strings.product.search') }}
                </b-button>
            </p>
        </b-field>

    </section>
</template>

<script>
export default {
    props: {
        retailers: {
            required: true,
            type: Object
        },
        stocks: {
            required: true,
            type: Object
        },
        genders: {
            required: true,
            type: Object
        },
        brands: {
            required: true,
            type: Object
        },
        seasons: {
            required: true,
            type: Object
        },
        categories: {
            required: true,
            type: Object
        },
        filters: {
            required: false,
            type: Object
        }
    },
    data() {
        return {
            currentFilters: undefined,
            selectedBrands:[]
        }
    },
    beforeMount() {
        this.currentFilters = this.filters;
    },
    computed:{
        filterBrands(){
            if(this.brands){
                return this.brands.data.map((e)=>{
                    return {
                        code:e.id,
                        label:e.name,
                        search:e.name.toLowerCase()
                    }
                });
            }
            return [];
        }
    },
    methods: {
        findBrand(options,search){
            const s = search.toLowerCase();
            return options.filter((o)=>o.search.indexOf(s)>=0);
        },
        handleSearchSubmit() {
            this.currentFilters = {
                ...this.currentFilters,
                brand_id:this.selectedBrands.map((e)=>e.code).join(","),
                sku: [],
            };
            this.$emit('handleProductSearch', this.currentFilters);
        },
        removeFilters() {
            this.currentFilters = {
                ...this.currentFilters,
                retailers: [],
                in_stock: [],
                brand_id: [],
                gender_id: [],
                category_id: [],
                season_id: [],
            };
            this.selectedBrands=[];
            this.$emit('handleProductSearch', this.currentFilters);
        },
        filterOutput(filterName) {
            return this[filterName].data.filter(option => {
                return (
                    option.name
                        .toString()
                        .toLowerCase()
                        .indexOf(this[filterName].input.toLowerCase()) >= 0
                )
            })
        },
        selectOptions(option, field) {
            this.currentFilters[field] = option ? option.id : null;
        },
        getCategoryPath(category) {
            let path = category.path.split('/')
            path.splice(-1,1);
            let prefix = ''
            for (let categoryId of path) {
                let category = _.find(this.categories.data, {id: parseInt(categoryId)});
                prefix += `${category.name} / `
            }
            return prefix;
        },
        handleOnChangeBrandInput(value) {
            if (!value) {
                this.currentFilters.brand_id = undefined;
            }
        }
    }
}
</script>
